import RepositoryFactory from "../../admin/apis/index";
const ecomReview = RepositoryFactory.ecomReview;

export default {
  addReview({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomReview.addReview(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getReview({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomReview.getReview(payload);
        commit("SET_REVIEW", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateReview({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomReview.updateReview(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteReview({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomReview.deleteReview(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
